export const audioExtensionRegex = /\.?(mp3|wav|ogg|flac|aac|m4a|webm)$/i;
export const fileAudioRegex = /^audio\/.+$/i;
